import { get, set, debounce } from "lodash";

import { store } from "@/configureStore";

const dispatch_action = (payload, guid) => {
  store.ref.dispatch({ ...payload, guid: guid });
}

const SearchActions = (props) => {
  return {
    initialize: async (results) => {
      dispatch_action({ type: "INITIALIZE_SEARCH_DATA", results }, props.guid);
    },

    fetch_results: async () => {
      dispatch_action({ type: "UPDATE_SEARCH_DATA_IS_LOADING", isLoading: true }, props.guid);
      const results = await props.dataFetcher()
      dispatch_action({ type: "INITIALIZE_SEARCH_DATA", results }, props.guid);
      dispatch_action({ type: "UPDATE_SEARCH_DATA_IS_LOADING", isLoading: false }, props.guid);
      return results;
    },

    updateInputValue: debounce((inputValue) => {
      dispatch_action({ type: "UPDATE_SEARCH_DATA_INPUT_VALUE", inputValue }, props.guid);
    }, 200),

    updateSelectedItem: (selectedItem) => {
      dispatch_action({ type: "UPDATE_SEARCH_DATA_SELECTED_ITEM", selectedItem }, props.guid);
    },

    updateStep: (step) => {
      store.ref?.dispatch({ type: "UPDATE_SEARCH_DATA_STEP", step });
    },
    updateIsLoading: (isLoading) => {
      dispatch_action({ type: "UPDATE_SEARCH_DATA_IS_LOADING", isLoading }, props.guid);
    },
    updateDefaultImage: (defaultImage) => {
      dispatch_action({ type: "UPDATE_SEARCH_DATA_DEFAULT_IMAGE", defaultImage }, props.guid);
    },
    search: (inputValue, results) => {
      let filteredResults = results;
      // console.log(`debounced ${inputValue}`)
      if (results && inputValue) {
        filteredResults = results.filter(item => item.name && item.name?.toLowerCase().includes(inputValue.toLowerCase()))
      }
      // console.log(`Results for search ${inputValue}`)
      // console.log(filteredResults)
      return filteredResults
    }

  }
}

export { SearchActions }